import { AxiosResponse } from "axios";
import {api} from "../config";

interface IMetaData {
    sellerId: number,
    marketName: string,
    category?: string
}

class marketCategoriesService {

    async getCategoriesForMarket(data: IMetaData): Promise<AxiosResponse> {
        return api.get(`/api/${data.sellerId}/seller-product/categories-for-market/${data.marketName && data.marketName}`);
    }

    async getDefaultMarketCategories(data: IMetaData): Promise<AxiosResponse> {
        return api.get(`/api/${data.sellerId}/seller-product/fields-meta-data-for-market/${data.marketName && data.marketName}`);
    }

    async getFieldsForCategory(data: IMetaData): Promise<AxiosResponse> {
        return api.get(`/api/${data.sellerId}/seller-product/fields-meta-data-for-category/${data.marketName}/${data.category}`);
    }

}

export default new marketCategoriesService();